// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2t44x","options":"AnswerScale_options__385IY","selected":"AnswerScale_selected__3HfT4"};